// ===================================================================
// src/app/hooks/useSupportChat.ts
//
// Store compartilhado (fora do React, mesmo padrão de
// useChatNotifications.ts) do painel flutuante de suporte
// (SupportChatLauncher.tsx): se está aberto e qual é o canal
// kind='support' do usuário logado. Fica fora do componente porque o
// AppLayout precisa ler este estado no handler do WS global — pra não
// mostrar toast de mensagem do suporte com o painel já aberto, e pra o
// "Ver" do toast abrir o painel em vez de navegar pro /chat.
// ===================================================================

import { useSyncExternalStore } from 'react';

export interface SupportChatState {
  open: boolean;
  /** id do ChatGroup kind='support' do usuário — null até carregar (ou se não tiver) */
  groupId: string | null;
}

let state: SupportChatState = { open: false, groupId: null };
const listeners = new Set<() => void>();

function setState(next: SupportChatState) {
  state = next;
  listeners.forEach((l) => l());
}

export function openSupportChat() {
  if (!state.open) setState({ ...state, open: true });
}

export function closeSupportChat() {
  if (state.open) setState({ ...state, open: false });
}

export function setSupportChatGroupId(groupId: string | null) {
  if (state.groupId !== groupId) setState({ ...state, groupId });
}

/** Leitura fora do React (ex: handler do WS em AppLayout). */
export function getSupportChatState(): SupportChatState {
  return state;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSupportChat(): SupportChatState {
  return useSyncExternalStore(subscribe, getSupportChatState);
}
